module.exports = __webpack_public_path__ + "img/4.e4d703a4.png";